var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJira1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8336 84.3334C41.9277 84.3334 44.8952 83.1043 47.0831 80.9164C49.271 78.7284 50.5002 75.761 50.5002 72.6668V61.0002H38.8336C35.7394 61.0002 32.772 62.2294 30.5841 64.4173C28.3961 66.6052 27.167 69.5727 27.167 72.6668C27.167 75.761 28.3961 78.7284 30.5841 80.9164C32.772 83.1043 35.7394 84.3334 38.8336 84.3334Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.167 49.3348C27.167 46.2406 28.3961 43.2732 30.5841 41.0853C32.772 38.8974 35.7394 37.6682 38.8336 37.6682H50.5002V61.0014H38.8336C37.3015 61.0014 35.7844 60.6996 34.369 60.1133C32.9535 59.527 31.6674 58.6677 30.5841 57.5843C29.5007 56.501 28.6414 55.2149 28.0551 53.7994C27.4688 52.384 27.167 50.8669 27.167 49.3348Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.167 27.1672C27.167 24.3824 28.3961 21.7117 30.5841 19.7426C32.772 17.7735 35.7394 16.6672 38.8336 16.6672H50.5002V37.6671H38.8336C35.7394 37.6671 32.772 36.5609 30.5841 34.5917C28.3961 32.6226 27.167 29.9519 27.167 27.1672Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.501 16.6672H62.1676C65.2617 16.6672 68.2292 17.7735 70.4171 19.7426C72.605 21.7117 73.8341 24.3824 73.8341 27.1672C73.8341 29.9519 72.605 32.6226 70.4171 34.5917C68.2292 36.5609 65.2617 37.6671 62.1676 37.6671H50.501V16.6672Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8332 49.3348C73.8332 52.429 72.604 55.3964 70.4161 57.5843C68.2282 59.7722 65.2608 61.0014 62.1666 61.0014C59.0724 61.0014 56.105 59.7722 53.9171 57.5843C51.7292 55.3964 50.5 52.429 50.5 49.3348C50.5 46.2406 51.7292 43.2732 53.9171 41.0853C56.105 38.8974 59.0724 37.6682 62.1666 37.6682C65.2608 37.6682 68.2282 38.8974 70.4161 41.0853C72.604 43.2732 73.8332 46.2406 73.8332 49.3348Z",
    fill: "#1ABCFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira1);
export default __webpack_public_path__ + "static/media/jira (1).a5401d3d330a6bd5639a767f442839ae.svg";
export { ForwardRef as ReactComponent };